<sh-label [type]="cell.labelType">{{cell.value}}</sh-label>
